// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBMCTnpR9igumKwJo0s9-gKmVVpbykqdKQ",
  authDomain: "bigpaisa-89967.firebaseapp.com",
  projectId: "bigpaisa-89967",
  storageBucket: "bigpaisa-89967.appspot.com",
  messagingSenderId: "416992228324",
  appId: "1:416992228324:android:fbdea0917de04dbddd4df1",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
